"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundTaskOut = void 0;
class BackgroundTaskOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return BackgroundTaskOut.attributeTypeMap;
    }
}
exports.BackgroundTaskOut = BackgroundTaskOut;
BackgroundTaskOut.discriminator = undefined;
BackgroundTaskOut.attributeTypeMap = [
    {
        "name": "data",
        "baseName": "data",
        "type": "any",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "status",
        "baseName": "status",
        "type": "BackgroundTaskStatus",
        "format": ""
    },
    {
        "name": "task",
        "baseName": "task",
        "type": "BackgroundTaskType",
        "format": ""
    }
];
//# sourceMappingURL=BackgroundTaskOut.js.map